var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDemoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.95 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1c3f75;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #4bac75;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.48 10.24 20.48 13.71 23.48 8.66 18.48 0 7.78 18.52 12.58 20.46 18.48 10.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "36.95 32 26.57 14.02 24.16 20.08 31.04 32 36.95 32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "0 32 5.91 32 9.76 25.34 6.19 21.28 0 32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.12 19.96 17.71 32 30.46 0 16.38 23.7 7.12 19.96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoIcon);
export default __webpack_public_path__ + "static/media/demo-icon.a07a6ce782620f555ca56a44a6991316.svg";
export { ForwardRef as ReactComponent };